import ehouse from "../../../../assets/images/productos/eHouse/EHOUSE.png";
import qr from "../../../../assets/images/QR Daniel Montes.svg";
import Producto from "../../../../components/producto";

import pic1 from "../../../../assets/images/productos/eHouse/Mosaico - EH1.jpg"; 
import pic2 from "../../../../assets/images/productos/eHouse/Mosaico - EH2.jpg"; 
import pic3 from "../../../../assets/images/productos/eHouse/Mosaico - EH3.jpg"; 
import pic4 from "../../../../assets/images/productos/eHouse/Mosaico - EH4.jpg"; 
import pic5 from "../../../../assets/images/productos/eHouse/Mosaico - EH5.jpg"; 

import { useTranslation } from "react-i18next";

function EHouse() {

    const {t} = useTranslation();

  return (
    <Producto
      fotos={[pic1, pic2, pic3, pic4, pic5]}
      datosTabla1={[
        [t("tensionMaximaDeServicio"), "kV", "36"],
        [t("corrienteNominal"), "A", "4.000"],
        [t("corrienteBreveDuracion"), "kA", "40"],
      ]}
      datosTabla2={[]}
      nombreProducto={"E-HOUSE"}
      fotoProducto={ehouse}
      descripcionProducto={
        t("e-house.titulo_descripcion")
      }
      caracteristicas={[
        t("e-house.bullet1"),
        t("e-house.bullet2"),
        t("e-house.bullet3"),
        t("e-house.bullet4"),
        t("e-house.bullet5"),
        t("e-house.bullet6")
      ]}
      vendedor={{
        nombre: "Daniel Montes",
        telefono: "+54 9 11 3167-6868",
        mail: "dmontes@ema.com.ar",
        qr: qr,
      }}
      pathPdf={'/assets/docs/2025%20-%20E-House.pdf'}
      tieneTabla2={false}
    />
  );
}

export default EHouse;